module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_5010.03b519c8.png";